import React, { useEffect, useState } from 'react';
import { getCookie } from '../../helpers/cookie';
import { CookiesBanner } from '../../ui';
import dayjs from 'dayjs';


const ManageCookiesBanner = () => {
  const [acceptedCookies, setAcceptedCookies] = useState(false)

  //Missing: save the strictly always, manage those selected making sure those not accepted get cleared

  useEffect(() => {
    const cookieValue = getCookie('cookie_notice_accepted');
    setAcceptedCookies(cookieValue);
  }, [])

  const accept = (cookiesLevel) => {
    const expiryDate = dayjs().add(1, 'year').toDate().toUTCString();
    const cookieValue = encodeURIComponent(JSON.stringify(cookiesLevel));
    document.cookie = `cookie_notice_accepted=${cookieValue};expires=${expiryDate};path=/`;
    setAcceptedCookies(cookiesLevel);
  }

  return (
    <CookiesBanner visible={!acceptedCookies} accept={accept} />
  );
}

export default ManageCookiesBanner;
